export default __webpack_public_path__ + "static/media/talentimages.7a66af80.jpg";